export enum PermissionLevel {
  NONE = "none",
  READ_ONLY = "read-only",
  MODIFY = "modify",
}

export interface AdminPagePermission {
  pageKey: string;
  pageName: string;
  level: PermissionLevel;
}

export const ADMIN_PAGES = {
  ADMIN_VIEW: "admin-view",
  REGISTERS: "registers",
  FUNDRAISING: "fundraising",
  TRADING: "trading",
  SWAPS: "swaps",
  REDEMPTIONS: "redemptions",
  INVESTORS: "investors",
  INVESTOR_RELATIONS: "investor-relations",
  DOCUMENTS: "documents",
  ACTIVITY: "activity",
  COMPANY_INFORMATION: "company-information",
  SETTINGS: "settings",
  DISTRIBUTIONS: "distributions",
} as const;

export const ADMIN_PAGE_LABELS: Record<string, string> = {
  [ADMIN_PAGES.ADMIN_VIEW]: "Admin view",
  [ADMIN_PAGES.REGISTERS]: "Registers",
  [ADMIN_PAGES.FUNDRAISING]: "Fundraising",
  [ADMIN_PAGES.TRADING]: "Trading",
  [ADMIN_PAGES.SWAPS]: "Swaps",
  [ADMIN_PAGES.REDEMPTIONS]: "Redemptions",
  [ADMIN_PAGES.INVESTORS]: "Investors",
  [ADMIN_PAGES.INVESTOR_RELATIONS]: "Investor Relations",
  [ADMIN_PAGES.DOCUMENTS]: "Documents",
  [ADMIN_PAGES.ACTIVITY]: "Activity",
  [ADMIN_PAGES.COMPANY_INFORMATION]: "Company Information",
  [ADMIN_PAGES.SETTINGS]: "Settings",
  [ADMIN_PAGES.DISTRIBUTIONS]: "Distributions",
};

export const ADMIN_PAGE_ROUTES: Record<string, string[]> = {
  [ADMIN_PAGES.ADMIN_VIEW]: ["admin-view"],
  [ADMIN_PAGES.REGISTERS]: ["shares-register", "options-register", "notes-register", "register", "investor-holdings"],
  [ADMIN_PAGES.FUNDRAISING]: ["fundraises", "fundraise"],
  [ADMIN_PAGES.TRADING]: ["trading"],
  [ADMIN_PAGES.SWAPS]: ["swaps"],
  [ADMIN_PAGES.REDEMPTIONS]: ["redemptions"],
  [ADMIN_PAGES.INVESTORS]: ["investors"],
  [ADMIN_PAGES.INVESTOR_RELATIONS]: ["investor-relations", "announcements", "invitations", "contacts"],
  [ADMIN_PAGES.DOCUMENTS]: ["documents"],
  [ADMIN_PAGES.ACTIVITY]: ["activity"],
  [ADMIN_PAGES.COMPANY_INFORMATION]: ["company-information"],
  [ADMIN_PAGES.SETTINGS]: ["settings"],
  [ADMIN_PAGES.DISTRIBUTIONS]: ["distributions"],
};

export type AdminPermissions = Record<string, PermissionLevel>;

